/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantBasicDataViewModel } from '../../models/merchant-basic-data-view-model';

export interface GetMerchantBasicData$Params {
  merchantId: string;
}

export function getMerchantBasicData(http: HttpClient, rootUrl: string, params: GetMerchantBasicData$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantBasicDataViewModel>> {
  const rb = new RequestBuilder(rootUrl, getMerchantBasicData.PATH, 'get');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantBasicDataViewModel>;
    })
  );
}

getMerchantBasicData.PATH = '/merchants/{merchantId}/basic-data';
